import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigAdmin";
import Constant from "../../constants";
import { Multiselect } from "multiselect-react-dropdown";
import { Link } from "react-router-dom";
// import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { adminPath } from "../../helpers/adminRoles";
import "./RetailerDocuments.css";
const moment = require("moment");

export default class Createretailers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      retailer_data: "",
      type: "password",
      options: [],
      img: "/images/doctor-img/Login screens/hide_icon.svg",
      // Newly picked files, keyed by document field. Each entry is
      // { base64, name }. Empty until the admin chooses a file.
      documents: {},
      // Signed URLs for documents already stored against this retailer, filled
      // in by getRetailerData when editing.
      documentLinks: {},
    };
    this.showPassword = this.showPassword.bind(this);
  }

  // The four KYC documents captured on this form. Only the registration
  // document is required, and only when creating a new pharmacy.
  documentFields = [
    { key: "registration_doc", label: "Registration Document", required: true },
    { key: "account_doc", label: "Account Document", required: false },
    { key: "gst_doc", label: "GST Document", required: false },
    { key: "pan_doc", label: "PAN Document", required: false },
  ];

  // Kept in step with ALLOWED_MIME_TYPES / MAX_DOCUMENT_BYTES in
  // app/helpers/retailerDocuments.js so the user gets an immediate error
  // instead of a round trip.
  allowedDocumentTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/webp",
    "application/pdf",
  ];

  maxDocumentBytes = 5 * 1024 * 1024;

  convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  handleDocumentChange = async (field, event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    if (this.allowedDocumentTypes.indexOf(file.type) === -1) {
      toast.error("Only JPG, PNG, WEBP or PDF files are allowed");
      event.target.value = "";
      return;
    }
    if (file.size > this.maxDocumentBytes) {
      toast.error("File must be 5 MB or smaller");
      event.target.value = "";
      return;
    }

    try {
      const base64 = await this.convertFileToBase64(file);
      const documents = Object.assign({}, this.state.documents);
      documents[field] = { base64: base64, name: file.name };
      const errors = Object.assign({}, this.state.errors);
      errors[field] = "";
      this.setState({ documents: documents, errors: errors });
    } catch (err) {
      toast.error("Unable to read the selected file");
      event.target.value = "";
    }
  };

  removeDocument = (field) => {
    const documents = Object.assign({}, this.state.documents);
    delete documents[field];
    this.setState({ documents: documents });
  };

  // Only sends documents the admin actually picked. Omitted fields mean "keep
  // what is already stored", which is what the update endpoint expects.
  buildDocumentPayload = () => {
    const payload = {};
    this.documentFields.forEach((field) => {
      const picked = this.state.documents[field.key];
      if (picked) payload[field.key] = picked.base64;
    });
    return payload;
  };

  // Renders the upload control. It is a sibling of the text field's form-group
  // inside the same column, using the same label/control structure as every
  // other field so it lines up with the rest of the grid. The status line below
  // the input keeps a fixed height whether or not a file is chosen, so picking
  // one does not shift the layout.
  renderDocumentUpload = (fieldKey, label, required) => {
    const picked = this.state.documents[fieldKey];
    const existingUrl = this.state.documentLinks[fieldKey];

    return (
      <div className="form-group retailer-doc">
        <label>
          {label}
          {required ? <span className="cRed"> *</span> : null}
        </label>
        <input
          type="file"
          name={fieldKey}
          accept=".jpg,.jpeg,.png,.webp,.pdf"
          className="form-control retailer-doc-input"
          onChange={this.handleDocumentChange.bind(this, fieldKey)}
        />
        <div className="retailer-doc-status">
          {picked ? (
            <span className="retailer-doc-file" title={picked.name}>
              {picked.name}
              <button
                type="button"
                className="retailer-doc-remove"
                onClick={this.removeDocument.bind(this, fieldKey)}
              >
                Remove
              </button>
            </span>
          ) : existingUrl ? (
            <a href={existingUrl} target="_blank" rel="noopener noreferrer">
              View uploaded document
            </a>
          ) : (
            <span className="retailer-doc-hint">
              JPG, PNG or PDF &middot; max 5 MB
            </span>
          )}
        </div>
        <span className="cRed">{this.state.errors[fieldKey]}</span>
      </div>
    );
  };
  //  for setStartTimeOnChange
  setStartTimeOnChange = (field, event) => {
    let expDate = event.target.value;
    this.setState({ registration_expirity: expDate });
    this.state.fields["registration_expirity"] =
      moment(expDate).format("YYYY-MM-DD");
    let count = expDate.search("-");
    if (count > 0) {
      let dateString = expDate.split("-");
      if (dateString[0].length != 4) {
        toast.error("Invalid expired date");
        return;
      }
    }

    let fields = this.state.fields;
    fields[field] = event.target.value;
    this.setState({ fields });
    this.state.errors[field] = "";
  };
  // for showPassword
  showPassword() {
    let type = this.state.type;
    if (this.state.type) {
      if (this.state.type == "input") {
        this.state.type = "password";
        this.state.img = "/images/doctor-img/Login screens/hide_icon.svg";
      } else {
        this.state.type = "input";
        this.state.img = "/images/doctor-img/Login screens/unhide_icon.svg";
      }
    }
    this.forceUpdate();
  }

  // To get detais after first render
  componentDidMount = () => {
    const { handle } = this.props.match.params;
    this.getRetailerInfo(handle);
    this.fetchCountryCurrencyDetails();
  };

  // When value changes of the fields
  handleChange = (field, event) => {
    const value = event.target.value;
    console.log("value--------", value)

    // Clone the fields object to avoid direct state mutation
    this.setState(prevState => ({
      fields: {
        ...prevState.fields,
        [field]: value
      }
    }), () => {
      console.log("Updated fields:", this.state.fields);
    });
  };
  // handleChange = (field, event) => {
  //   console.log("event.target.value---------",event.target.value)
  //   let fields = this.state.fields;
  //   fields[field] = event.target.value;
  //   this.setState({ fields });
  //   console.log("fields----------",fields);
  // };
  //  for emailValidation
  emailValidation = (field, event) => {
    var email = document.getElementById("txtEmailId").value;
    var filter =
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!filter.test(email)) {
      toast.error("Please provide a valid email address");
      return false;
    }
  };
  // To get all the ResponderInfo
  getRetailerInfo(handle) {
    Httpconfig.httptokenget(Constant.siteurl + "api/retailer/" + handle)
      .then((response) => {
        this.setState({
          fields: {
            storename: response.data.data[0].storename,
            mobile_number: response.data.data[0].mobile_number,
            email: response.data.data[0].email,
            password: response.data.data[0].tbl_user.password,
            registration_number: response.data.data[0].registration_number,
            registration_expirity: response.data.data[0].registration_expirity,
            address: response.data.data[0].address,
            latitude: response.data.data[0].latitude,
            longitude: response.data.data[0].longitude,
            currency: response.data.data[0].currency,

            bank_name: response.data.data[0].bank_name,
            account_number: response.data.data[0].account_number,
            account_holder_name: response.data.data[0].account_holder_name,
            ifsc_code: response.data.data[0].ifsc_code,
            upi_number: response.data.data[0].upi_number,
            gst_number: response.data.data[0].gst_number,
            pan_number: response.data.data[0].pan_number,
            commission: response.data.data[0].commission,
            is_active: response.data.data[0].is_active,
            cod_enabled: String(response.data.data[0].cod_enabled),
            cod_min_order_value: response.data.data[0].cod_min_order_value,
          },
          documentLinks: {
            registration_doc:
              response.data.data[0].registration_doc_signed_url || "",
            account_doc: response.data.data[0].account_doc_signed_url || "",
            gst_doc: response.data.data[0].gst_doc_signed_url || "",
            pan_doc: response.data.data[0].pan_doc_signed_url || "",
          },
        });
      })
      .catch((error) => { });
  }

  // create or update
  checkSubmit(event) {
    event.preventDefault();
    const { handle } = this.props.match.params;
    if (this.handleValidation() && handle) {
      this.updateRetailers(event);
    } else if (this.handleValidation() && handle == undefined) {
      this.createRetailer(event);
    } else {
      //toast.warn("Form has errors.");
    }
  }
  //  for getting country currency details
  fetchCountryCurrencyDetails() {
    Httpconfig.httptokenget(Constant.siteurl + "api/Country")
      .then((response) => {
        this.setState({
          countryData: response.data.data,
        });
      })
      .catch((error) => { });
  }

  // creates new controller
  createRetailer = (event) => {
    event.preventDefault();
    const { fields, errors } = this.state;

    let expDate = moment(this.state.registration_expirity).format("YYYY-MM-DD");

    Httpconfig.httptokenpost(Constant.siteurl + "api/retailer/", {
      storename: fields["storename"],
      email: fields["email"],
      mobile_number: fields["mobile_number"],
      password: fields["password"],
      registration_expirity: expDate,
      registration_number: fields["registration_number"],
      address: fields["address"],
      latitude: fields["latitude"],
      longitude: fields["longitude"],

      bank_name: fields["bank_name"],
      account_number: fields["account_number"],
      account_holder_name: fields["account_holder_name"],
      ifsc_code: fields["ifsc_code"],
      upi_number: fields["upi_number"],
      gst_number: fields["gst_number"],
      pan_number: fields["pan_number"],
      commission: fields["commission"],
      is_active: fields["is_active"],
      cod_enabled: fields["cod_enabled"],
      cod_min_order_value: fields["cod_min_order_value"],
      // Opts this request in to the mandatory-registration-document check.
      // Other callers of this endpoint do not send it and are unaffected.
      enforce_documents: 1,
      ...this.buildDocumentPayload(),
    })
      .then((response) => {
        if (response.data.status == 200) {
          toast.success("Successfully Created Pharmacy");
          setTimeout(
            () => this.props.history.push("/admin/Viewretailers"),
            1000
          );
        } else if (response.status == 204) {
          toast.error("Email or Mobile Number already assosiated with us...");
        }
      })
      .catch((error) => {
        const message =
          error.response && error.response.data && error.response.data.message;
        if (message) toast.error(message);
      });
  };

  // updates controller
  updateRetailers = (event) => {
    event.preventDefault();
    const { handle } = this.props.match.params;
    const { fields, errors } = this.state;

    Httpconfig.httptokenput(Constant.siteurl + "api/retailer/" + handle, {
      storename: fields["storename"],
      email: fields["email"],
      mobile_number: fields["mobile_number"],
      registration_expirity: this.state.fields["registration_expirity"],
      registration_number: fields["registration_number"],
      address: fields["address"],
      latitude: fields["latitude"],
      longitude: fields["longitude"],

      bank_name: fields["bank_name"],
      account_number: fields["account_number"],
      account_holder_name: fields["account_holder_name"],
      ifsc_code: fields["ifsc_code"],
      upi_number: fields["upi_number"],
      gst_number: fields["gst_number"],
      pan_number: fields["pan_number"],
      commission: fields["commission"],
      is_active: fields["is_active"],
      cod_enabled: fields["cod_enabled"],
      cod_min_order_value: fields["cod_min_order_value"],
      password: fields["password"],
      // No enforce_documents here: on edit, documents already stored stay as
      // they are and only re-uploaded files are sent.
      ...this.buildDocumentPayload(),
    })
      .then((response) => {
        if (response.data.status == 200 && !response.data.error) {
          toast.success(response.data.message);
          setTimeout(
            () => this.props.history.push(adminPath("Viewretailers")),
            2000
          );
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        const message =
          error.response && error.response.data && error.response.data.message;
        toast.error(message || "Unable to update Pharmacy, please try later");
      });
  };

  //  For validating the fields
  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    // Every pharmacy must have a registration document, so the field is marked
    // mandatory on both create and edit. On edit a document already stored
    // against the retailer satisfies it - the admin only has to pick a file
    // when there is nothing on record yet.
    const hasStoredRegistrationDoc =
      !!this.state.documentLinks["registration_doc"];
    if (
      !this.state.documents["registration_doc"] &&
      !hasStoredRegistrationDoc
    ) {
      formIsValid = false;
      errors["registration_doc"] = "Registration document is required";
    }

    if (!fields["storename"]) {
      formIsValid = false;
      errors["storename"] = "Store name cannot be empty";
    }
    if (!fields["mobile_number"]) {
      formIsValid = false;
      errors["mobile_number"] = "Mobile Number cannot be empty";
    }
    if (!fields["registration_number"]) {
      formIsValid = false;
      errors["registration_number"] = "Registration Number cannot be empty";
    }
    if (!fields["email"]) {
      formIsValid = false;
      errors["email"] = "Email cannot be empty";
    }
    if (!fields["registration_expirity"]) {
      formIsValid = false;
      errors["registration_expirity"] = "Expiry Date cannot be empty";
    }
    if (!fields["password"]) {
      formIsValid = false;
      errors["password"] = "Password cannot be empty";
    }
    if (!fields["address"]) {
      formIsValid = false;
      errors["address"] = "Address cannot be empty";
    }
    // Latitude / longitude must be plain decimal degrees. The customer app
    // computes the nearby-store distance from these columns in SQL, so anything
    // else (17.4336 N, 78°23'E, ...) is silently truncated to a wrong number and
    // the pharmacy never falls inside the search radius.
    if (!fields["latitude"]) {
      formIsValid = false;
      errors["latitude"] = "Latitude cannot be empty";
    } else if (
      !/^-?\d+(\.\d+)?$/.test(String(fields["latitude"]).trim()) ||
      Math.abs(Number(fields["latitude"])) > 90
    ) {
      formIsValid = false;
      errors["latitude"] =
        "Enter latitude in decimal degrees between -90 and 90 (e.g. 17.4363944)";
    }
    if (!fields["longitude"]) {
      formIsValid = false;
      errors["longitude"] = "Longitude cannot be empty";
    } else if (
      !/^-?\d+(\.\d+)?$/.test(String(fields["longitude"]).trim()) ||
      Math.abs(Number(fields["longitude"])) > 180
    ) {
      formIsValid = false;
      errors["longitude"] =
        "Enter longitude in decimal degrees between -180 and 180 (e.g. 78.3877334)";
    }

    if (!fields["bank_name"]) {
      formIsValid = false;
      errors["bank_name"] = "Bank Name cannot be empty";
    }
    if (!fields["account_number"]) {
      formIsValid = false;
      errors["account_number"] = "Account Number cannot be empty";
    }
    if (!fields["account_holder_name"]) {
      formIsValid = false;
      errors["account_holder_name"] = "Account Holder cannot be empty";
    }
    if (!fields["ifsc_code"]) {
      formIsValid = false;
      errors["ifsc_code"] = "IFSC Code cannot be empty";
    }
    if (!fields["upi_number"]) {
      formIsValid = false;
      errors["upi_number"] = "UPI cannot be empty";
    }
    if (!fields["pan_number"]) {
      formIsValid = false;
      errors["pan_number"] = "PAN Number cannot be empty";
    }

    if (!fields["commission"]) {
      formIsValid = false;
      errors["commission"] = "Commission cannot be empty";
    }

    if (fields["cod_enabled"] == "1") {
      const codMinValue =
        fields["cod_min_order_value"] == null
          ? ""
          : String(fields["cod_min_order_value"]).trim();

      if (!codMinValue) {
        formIsValid = false;
        errors["cod_min_order_value"] =
          "COD Minimum Order Value cannot be empty when COD is enabled";
      } else if (!/^\d+(\.\d{1,2})?$/.test(codMinValue)) {
        formIsValid = false;
        errors["cod_min_order_value"] =
          "Enter a valid amount (positive number up to 2 decimals, e.g. 400.00)";
      } else if (Number(codMinValue) <= 0) {
        formIsValid = false;
        errors["cod_min_order_value"] =
          "COD Minimum Order Value must be greater than 0";
      }
    }

    this.setState({ errors: errors });
    return formIsValid;
  }

  render() {
    const { fields, errors, coupon_data, countryData } = this.state;
    return (
      <section id="main_dashboard">
        <div className="container" id="main_front">
          <div className="row">
            <div className="col-md-12">
              <div className="dash-section">
                <div className="section-header">
                  <ol className="breadcrumb">
                    <li className="active">
                      <Link to="/admin"> Dashboard</Link> &gt;
                      <a> Pharmacies </a>
                    </li>
                  </ol>
                </div>
              </div>

              <section id="CMS_tab">
                <div className="CMS_content">
                  <div className="container">
                    <div className="row">
                      <div className="tab-header">
                        <h3>Create Pharmacy </h3>
                      </div>
                      <div id="reg_form">
                        <form
                          className="retailer-form"
                          onSubmit={this.checkSubmit.bind(this)}
                        >
                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  Store Name<span className="cRed"> *</span>
                                </label>
                                <input
                                  type="text"
                                  name="storename"
                                  value={this.state.fields["storename"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "storename"
                                  )}
                                  className="form-control"
                                  placeholder="Store Name"
                                />
                                <span className="cRed">
                                  {this.state.errors["storename"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  Mobile Number<span className="cRed"> *</span>
                                </label>
                                <input
                                  type="text"
                                  name="mobile_number"
                                  value={
                                    this.state.fields["mobile_number"] || ""
                                  }
                                  onChange={this.handleChange.bind(
                                    this,
                                    "mobile_number"
                                  )}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  minLength="10"
                                  maxlength="10"
                                  className="form-control"
                                  placeholder="Mobile Number"
                                />
                                <span className="cRed">
                                  {this.state.errors["mobile_number"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  Email address<span className="cRed"> *</span>
                                </label>
                                <input
                                  type="text"
                                  name="email"
                                  id="txtEmailId"
                                  autoComplete="new-password"
                                  value={this.state.fields["email"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "email"
                                  )}
                                  className="form-control"
                                  placeholder="Email address"
                                />
                                <span className="cRed">
                                  {this.state.errors["email"]}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  Enter Password<span className="cRed"> *</span>
                                </label>
                                <input
                                  type={this.state.type}
                                  name="password"
                                  autoComplete="new-password"
                                  value={this.state.fields["password"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "password"
                                  )}
                                  className="form-control"
                                  placeholder="Enter Password"
                                />
                                <img
                                  class="password_view_retailer"
                                  onClick={this.showPassword}
                                  src={this.state.img}
                                />
                                <span className="cRed">
                                  {this.state.errors["password"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  Registration Number<span className="cRed"> *</span>
                                </label>
                                <input
                                  type="text"
                                  name="registration_number"
                                  value={
                                    this.state.fields["registration_number"] ||
                                    ""
                                  }
                                  onChange={this.handleChange.bind(
                                    this,
                                    "registration_number"
                                  )}
                                  className="form-control"
                                  placeholder="Registration Number"
                                />
                                <span className="cRed">
                                  {this.state.errors["registration_number"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  Registration Expiry<span className="cRed"> *</span>
                                </label>
                                {/* <DatePicker
                                  name="registration_expirity"
                                  minDate={new Date()}
                                  autoComplete="off"
                                  className="dateInput"
                                  placeholderText="Registration Expiry"
                                  selected={this.state.registration_expirity}
                                  onChange={this.setStartTimeOnChange}
                                  value={
                                    this.state.fields["registration_expirity"]
                                  }
                                  dateFormat="dd-MM-yyyy"
                                  yearDropdownItemNumber={100}
                                  scrollableYearDropdown={true}
                                  showYearDropdown
                                  showMonthDropdow
                                /> */}
                                <input
                                  type="date"
                                  id="registration_expirity"
                                  name="registration_expirity"
                                  className="form-control"
                                  value={
                                    this.state.fields["registration_expirity"]
                                  }
                                  min={moment().format("YYYY-MM-DD")}
                                  onChange={this.setStartTimeOnChange.bind(
                                    this,
                                    "registration_expirity"
                                  )}
                                />
                                <span className="cRed">
                                  {this.state.errors["registration_expirity"]}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4">
                              {this.renderDocumentUpload(
                                "registration_doc",
                                "Registration Document",
                                true
                              )}
                            </div>

                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  Address<span className="cRed"> *</span>
                                </label>
                                <input
                                  type="text"
                                  name="address"
                                  value={this.state.fields["address"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "address"
                                  )}
                                  className="form-control"
                                  placeholder="Address"
                                />
                                <span className="cRed">
                                  {this.state.errors["address"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  Latitude<span className="cRed"> *</span>
                                </label>
                                <input
                                  type="text"
                                  name="latitude"
                                  value={this.state.fields["latitude"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "latitude"
                                  )}
                                  className="form-control"
                                  placeholder="e.g. 17.4363944"
                                />
                                <span className="cRed">
                                  {this.state.errors["latitude"]}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  Longitude<span className="cRed"> *</span>
                                </label>
                                <input
                                  type="text"
                                  name="longitude"
                                  value={this.state.fields["longitude"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "longitude"
                                  )}
                                  className="form-control"
                                  placeholder="e.g. 78.3877334"
                                />
                                <span className="cRed">
                                  {this.state.errors["longitude"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  Bank Name<span className="cRed"> *</span>
                                </label>
                                <input
                                  type="text"
                                  name="bank_name"
                                  value={this.state.fields["bank_name"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "bank_name"
                                  )}
                                  className="form-control"
                                  placeholder="Bank Name"
                                />
                                <span className="cRed">
                                  {this.state.errors["bank_name"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  Account Number<span className="cRed"> *</span>
                                </label>
                                <input
                                  type="number"
                                  name="account_number"
                                  value={
                                    this.state.fields["account_number"] || ""
                                  }
                                  onChange={this.handleChange.bind(
                                    this,
                                    "account_number"
                                  )}
                                  className="form-control"
                                  placeholder="Account Number"
                                />
                                <span className="cRed">
                                  {this.state.errors["account_number"]}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4">
                              {this.renderDocumentUpload(
                                "account_doc",
                                "Account Document",
                                false
                              )}
                            </div>

                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  Account Holder Name<span className="cRed"> *</span>
                                </label>
                                <input
                                  type="text"
                                  name="account_holder_name"
                                  value={
                                    this.state.fields["account_holder_name"] ||
                                    ""
                                  }
                                  onChange={this.handleChange.bind(
                                    this,
                                    "account_holder_name"
                                  )}
                                  className="form-control"
                                  placeholder="Account Holder Name"
                                />
                                <span className="cRed">
                                  {this.state.errors["account_holder_name"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  IFSC Code<span className="cRed"> *</span>
                                </label>
                                <input
                                  type="text"
                                  name="ifsc_code"
                                  value={this.state.fields["ifsc_code"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "ifsc_code"
                                  )}
                                  className="form-control"
                                  placeholder="IFSC Code"
                                />
                                <span className="cRed">
                                  {this.state.errors["ifsc_code"]}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  UPI Number<span className="cRed"> *</span>
                                </label>
                                <input
                                  type="text"
                                  name="upi_number"
                                  value={this.state.fields["upi_number"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "upi_number"
                                  )}
                                  className="form-control"
                                  placeholder="UPI Number"
                                />
                                <span className="cRed">
                                  {this.state.errors["upi_number"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>GST Number</label>
                                <input
                                  type="text"
                                  name="gst_number"
                                  value={this.state.fields["gst_number"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "gst_number"
                                  )}
                                  className="form-control"
                                  placeholder="GST Number"
                                />
                                <span className="cRed">
                                  {this.state.errors["gst_number"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-4">
                              {this.renderDocumentUpload(
                                "gst_doc",
                                "GST Document",
                                false
                              )}
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  PAN Number<span className="cRed"> *</span>
                                </label>
                                <input
                                  type="text"
                                  name="pan_number"
                                  value={this.state.fields["pan_number"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "pan_number"
                                  )}
                                  className="form-control"
                                  placeholder="PAN Number"
                                />
                                <span className="cRed">
                                  {this.state.errors["pan_number"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-4">
                              {this.renderDocumentUpload(
                                "pan_doc",
                                "PAN Document",
                                false
                              )}
                            </div>

                            {/*
                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>Currency</label>
                                <select
                                  name="currency"
                                  className="form-control"
                                  value={this.state.fields["currency"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "currency"
                                  )}
                                >
                                  <option value="">Select</option>
                                  {countryData &&
                                    countryData.map((countryData, i) => {
                                      return (
                                        <option
                                          value={countryData.currency_symbol}
                                        >
                                          {countryData.currency_name}
                                        </option>
                                      );
                                    })}
                                </select>
                                <span className="cRed">
                                  {this.state.errors["currency"]}
                                </span>
                              </div>
                            </div> */}

                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>
                                  commission %<span className="cRed"> *</span>
                                </label>
                                <input
                                  type="number"
                                  name="commission"
                                  value={this.state.fields["commission"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "commission"
                                  )}
                                  className="form-control"
                                  placeholder="commission %"
                                />
                                <span className="cRed">
                                  {this.state.errors["commission"]}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>Status</label>
                                <div className="custom-control custom-radio">
                                  <input
                                    type="radio"
                                    value="1"
                                    checked={
                                      this.state.fields["is_active"] == "1"
                                    }
                                    name="is_active"
                                    onChange={this.handleChange.bind(
                                      this,
                                      "is_active"
                                    )}
                                  />{" "}
                                  Active &nbsp;&nbsp;&nbsp;
                                  <input
                                    type="radio"
                                    value="0"
                                    checked={
                                      this.state.fields["is_active"] == "0"
                                    }
                                    name="is_active"
                                    onChange={this.handleChange.bind(
                                      this,
                                      "is_active"
                                    )}
                                  />{" "}
                                  In Active
                                  <span className="cRed">
                                    {this.state.errors["status"]}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group ">
                                <label>COD Enabled</label>
                                <div className="custom-control custom-radio">
                                  <input
                                    type="radio"
                                    value="1"
                                    checked={
                                      this.state.fields["cod_enabled"] == "1"
                                    }
                                    name="cod_enabled"
                                    onChange={this.handleChange.bind(
                                      this,
                                      "cod_enabled"
                                    )}
                                  />{" "}
                                  Yes &nbsp;&nbsp;&nbsp;
                                  <input
                                    type="radio"
                                    value="0"
                                    checked={
                                      this.state.fields["cod_enabled"] == "0"
                                    }
                                    name="cod_enabled"
                                    onChange={this.handleChange.bind(
                                      this,
                                      "cod_enabled"
                                    )}
                                  />{" "}
                                  No
                                  <span className="cRed">
                                    {this.state.errors["cod_enabled"]}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {this.state.fields["cod_enabled"] == "1" && (
                              <div className="col-md-4">
                                <div className="form-group ">
                                  <label>
                                  COD Minimum Order Value<span className="cRed"> *</span>
                                </label>
                                  <input
                                    type="number"
                                    name="cod_min_order_value"
                                    min="0"
                                    step="0.01"
                                    value={
                                      this.state.fields["cod_min_order_value"] ||
                                      ""
                                    }
                                    onKeyDown={(event) => {
                                      if (
                                        ["-", "+", "e", "E"].includes(event.key)
                                      ) {
                                        event.preventDefault();
                                      }
                                    }}
                                    onChange={this.handleChange.bind(
                                      this,
                                      "cod_min_order_value"
                                    )}
                                    className="form-control"
                                    placeholder="Min order value eligible for COD"
                                  />
                                  <span className="cRed">
                                    {this.state.errors["cod_min_order_value"]}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="row">
                            <div className="form-group col-md-12">
                              <button
                                type="submit"
                                className="btn  btn-primary save_btn"
                                onClick={this.emailValidation.bind(this, "")}
                              >
                                Save Pharmacy
                              </button>{" "}
                              &nbsp;
                              <Link
                                to={adminPath("Viewretailers")}
                                className="cancel_btn"
                              >
                                Cancel
                              </Link>{" "}
                              &nbsp; &nbsp;
                            </div>
                          </div>
                        </form>
                      </div>
                      <ToastContainer />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
